<template>
    <div>
        <iframe id="pdf" :src="pdfDataUri" style="width: 100%; height: 900px;"></iframe>
    </div>
</template>

<script>
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
   
export default {
    name: 'displayCert',

    data: () => ({
        name: null,
        expiry: null,
        accred: null,
        pdf: null,
        textSize: 30,
        pdfDataUri: "",
    }),
    created() {
        this.name = this.$route.params.name;
        this.expiry = this.$route.params.expiry;
        this.accred = this.$route.params.accred;
        this.pdf = this.$route.params.pdf;
        this.modifyPdf();
    },
    methods: {
        async modifyPdf() {
            const url = `${location.origin}/${this.pdf}`   //BQ_Coaching.pdf
             
            const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

            const pdfDoc = await PDFDocument.load(existingPdfBytes)
            // const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
            // const CourierFont = await pdfDoc.embedFont(StandardFonts.Courier)
            const TimesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)

            const pages = pdfDoc.getPages()
            const firstPage = pages[0]
            //const { width, height } = firstPage.getSize()
            const { width } = firstPage.getSize()
            
            const accredWidth = TimesRomanFont.widthOfTextAtSize(this.accred, this.textSize);
            const nameWidth = TimesRomanFont.widthOfTextAtSize(this.name, this.textSize);
            //const textHeight = helveticaFont.heightAtSize(this.textSize);
            

            // Write the Accrediation Type
            firstPage.drawText(this.accred, {
                x: width / 2 - accredWidth / 2,
                y: 315, 
                // height / 2 - accredHeight / 2, - if we wanted to center the height as well
                size: this.textSize,
                font: TimesRomanFont,
                // color: rgb(1, 1, 1), // White
                // color: rgb(0, 0, 0), // Black
                color: rgb(1, 0.54, 0),  // Orange
                // rotate: degrees(-45),
            })

            // Write the Persons name
            firstPage.drawText(this.name, {
                x: width / 2 - nameWidth / 2,
                y: 215, 
                // height / 2 - accredHeight / 2, - if we wanted to center the height as well
                size: (this.textSize * 1),
                font: TimesRomanFont,
                // color: rgb(1, 1, 1), // White
                // color: rgb(0, 0, 0), // Black
                color: rgb(1, 0.54, 0),  // Orange
                // rotate: degrees(-45),
            })
            // Write the expiry date
            firstPage.drawText(this.expiry, {
                x: 580,
                y: 80, 
                size: (this.textSize * .5),
                font: TimesRomanFont,
                 // color: rgb(1, 1, 1), // White
                // color: rgb(0, 0, 0), // Black
                color: rgb(1, 0.54, 0),  // Orange
                // rotate: degrees(-45),
            })

            this.pdfDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
        },
    },
}
</script>

<style lang="scss" scoped>

</style>